module.exports = __webpack_public_path__ + "assets/img/146515.37ec3296.svg";